/**
 * Trunnion AI - Status Dot Component
 */

interface StatusDotProps {
  status: 'healthy' | 'degraded' | 'unhealthy' | 'running' | 'success' | 'failed' | 'pending' | 'idle';
  size?: 'sm' | 'md';
  pulse?: boolean;
}

const colorMap: Record<string, string> = {
  healthy: 'bg-green-400',
  running: 'bg-blue-400',
  success: 'bg-green-400',
  pending: 'bg-yellow-400',
  degraded: 'bg-yellow-400',
  failed: 'bg-red-400',
  unhealthy: 'bg-red-400',
  idle: 'bg-trunnion-slate-500',
};

const sizeMap = {
  sm: 'h-2 w-2',
  md: 'h-2.5 w-2.5',
};

export function StatusDot({ status, size = 'sm', pulse = false }: StatusDotProps) {
  const shouldPulse = pulse || status === 'running' || status === 'pending';

  return (
    <span className="relative flex items-center justify-center">
      <span
        className={`rounded-full ${colorMap[status] ?? 'bg-trunnion-slate-500'} ${sizeMap[size]}`}
      />
      {shouldPulse && (
        <span
          className={`absolute rounded-full ${colorMap[status] ?? 'bg-trunnion-slate-500'} ${sizeMap[size]} animate-ping opacity-75`}
        />
      )}
    </span>
  );
}
